@if (open && structure) {
  <div class="relative z-50">
    <!-- Overlay -->
    <div class="fixed inset-0 bg-primary-strong/80 transition-opacity"></div>
    <!-- Modal Container -->
    <div
      class="fixed inset-0 z-20 flex items-end justify-center p-4 text-center sm:items-center sm:p-0"
    >
      <div
        class="shadow-xl relative w-full transform overflow-hidden rounded-lg bg-white py-4 text-center transition-all sm:max-w-lg lg:py-6"
      >
        <!-- Modal Header -->
        <div class="bg-white pb-4">
          <div class="flex flex-col items-center space-y-4">
            <!-- Icon -->
            <div
              class="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-red-100 sm:h-16 sm:w-16"
            >
              <svg
                class="size-7 text-red-600 sm:size-10"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                aria-hidden="true"
                data-slot="icon"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
                />
              </svg>
            </div>
            <!-- Countdown below the icon -->
            @if (structure.countdown !== undefined) {
              <div class="mt-2">
                <p class="font-freightSansProBold text-xs text-primary-active">
                  La sesión se cerrará en {{ structure.countdown }} segundos
                </p>
              </div>
            }
            <!-- Text -->
            <div class="text-center">
              <h3 class="font-freightSansProBold text-lg text-primary-active">
                {{ structure.title }}
              </h3>
              <p class="font-freightSansProBold text-lg text-primary-active">
                {{ structure.question }}
              </p>
            </div>
          </div>
        </div>
        <!-- Modal Footer -->
        <div class="justify-center bg-white px-4 sm:flex sm:space-x-4 sm:px-6">
          <button
            type="button"
            (click)="onPrimaryClick($event)"
            class="shadow-sm inline-flex h-12 w-full items-center justify-center rounded-md bg-primary-normal px-3 py-2 font-freightSansProSemibold text-base text-white hover:bg-primary-hover sm:w-[232px] sm:flex-auto"
          >
            {{ structure.primaryButtonText }}
          </button>
          <button
            type="button"
            (click)="onWarningClick($event)"
            class="shadow-sm mt-3 inline-flex h-12 w-full items-center justify-center rounded-md bg-tertiary-normal px-3 py-2 font-freightSansProSemibold text-base text-white hover:bg-tertiary-hover sm:mt-0 sm:w-[232px] sm:flex-auto"
          >
            {{ structure.warningButtonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
}
